/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Partner_Add_Contract_CreatedInputs */



/**
* | output |
* | --- |
* | "{name} is ready and waiting for its start date." |
*
* @param {Partner_Add_Contract_CreatedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_add_contract_created = /** @type {((inputs: Partner_Add_Contract_CreatedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Add_Contract_CreatedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.name} ist angelegt und wartet auf den Starttermin.`)
	return /** @type {LocalizedString} */ (`${i?.name} is ready and waiting for its start date.`)
});